import React from "react";
import { Table, Container } from "react-bootstrap";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { LoadingComponent } from "../../Components/Loading";
import { useOrders } from "../../Shared/Hooks/useOrders";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { formatCurrency } from "../../Shared/helpers/currency";
import routes from "../../Helpers/Routes.json";

function OrdersDetailPage() {
  const params = useParams();
  const { orders, loading } = useOrders({}, params.order);
  const { t } = useTranslation();

  if (loading) {
    return <LoadingComponent />;
  }

  const metadata = orders.meta_data.filter((i) => i.key === "delivery_at");
  const wooStatus = {
    pending: t("Pendiente de cobro"),
    processing: t("Procesando"),
    "on-hold": t("En espera"),
    completed: t("Completado"),
    cancelled: t("Cancelado"),
    refunded: t("Reembolsado"),
    failed: t("Fallido"),
  };

  return (
    <Container className="py-4" style={{ maxWidth: "800px" }}>
      <div className="card p-4">
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <h1 className="h3 fw-bold mb-1">
              {t("Pedido")} #{orders.id}
            </h1>
            <small className="text-muted d-block">
              {t("Fecha de pedido")}:{" "}
              {new Date(orders.date_created).toLocaleDateString(
                i18next.language,
                { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }
              )}
            </small>
            {metadata && metadata[0] && (
              <small className="text-muted d-block">
                {t("Entrega")}: {metadata[0].value}
              </small>
            )}
          </div>
          <span
            className={`badge rounded-pill ${
              orders.needs_payment ? "bg-warning text-dark" : "bg-success"
            }`}
          >
            {orders.needs_payment ? t("Pendiente de cobro") : "Pagado"}
          </span>
        </div>

        <div className="d-flex gap-4 mb-3 small">
          <div>
            <span className="text-muted">{t("Forma de pago")}:</span>{" "}
            <strong>
              {parseFloat(orders.total) < 0.5 ? "Descuentos" : orders.payment_method}
            </strong>
          </div>
          <div>
            <span className="text-muted">{t("Estado")}:</span>{" "}
            <strong>{wooStatus[orders.status]}</strong>
          </div>
        </div>

        <Table className="table-striped mb-3">
          <thead>
            <tr>
              <th>{t("Producto")}</th>
              <th>{t("Cantidad")}</th>
              <th className="text-end">{t("Total con IVA")}</th>
            </tr>
          </thead>
          <tbody>
            {orders.line_items.map(
              ({ id, name, price, quantity, subtotal_tax }) => (
                <tr key={`product-${id}`}>
                  <td>{t(name)}</td>
                  <td>{quantity}</td>
                  <td className="text-end">
                    {formatCurrency(
                      parseFloat(price * quantity) + parseFloat(subtotal_tax)
                    )}
                  </td>
                </tr>
              )
            )}
          </tbody>
        </Table>

        <div className="d-flex justify-content-between small mb-1">
          <span>{t("Descuentos")}:</span>
          <span>{formatCurrency(parseFloat(orders.discount_total))}</span>
        </div>
        <div className="d-flex justify-content-between fw-bold h5">
          <span>{t("Total")}:</span>
          <span>{formatCurrency(orders.total)}</span>
        </div>

        <div className="text-center mt-4">
          <Link
            to={routes.Homepage.index}
            className="btn btn-outline-dark rounded-pill"
          >
            {t("Volver")}
          </Link>
        </div>
      </div>
    </Container>
  );
}

export default OrdersDetailPage;
